module.exports = __webpack_public_path__ + "img/why-salem-safe.7b439ed6.svg";